import { render } from "./ElementsSelectSearchBar.vue?vue&type=template&id=65737b40"
import script from "./ElementsSelectSearchBar.vue?vue&type=script&lang=js"
export * from "./ElementsSelectSearchBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__